module.exports = __webpack_public_path__ + "img/bg.a71771c4.png";